// extracted by mini-css-extract-plugin
export default {"digits":"styles_digits__k4bue","digit":"styles_digit__C-ALz","digitOn":"styles_digitOn__uagi0","digitError":"styles_digitError__FCKKB"};